// src/pages/Patientsappointment.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Container, Button, Card, Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import {
  getAppointmentById,
} from "../api";

import NewPatientSession from "../Components/Sessions/NewPatientSession";

export function NewPatientsappointment() {
  const { appointmentId } = useParams();

  const [patient, setPatient] = useState(null);
  const [activeSection, setActiveSection] = useState("info"); // "info" | "eligibility" | "cases"

  const [isMobile, setIsMobile] = useState(false);
  const [userRole, setUserRole] = useState(false);


  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("user");
    if (token) {
      const decoded = jwtDecode(token);
      const roles = Array.isArray(decoded?.role) ? decoded.role : [];
      setUserRole(
        roles.includes("Practitioner") || roles.includes("SuperAdmin")
      );
    }
  }, []);

  useEffect(() => {
    async function load() {
      try {
        const p = await getAppointmentById(appointmentId);
        setPatient({...p, 
          patientFirstname: p.patientFirstName,
          patientLastname: p.patientLastName,
          patientEmail: p.patientEmail,
          patientCellNumber: p.patientPhone,
      })
      } catch (e) {
        console.error("Error fetching patient/account:", e);
      }
    }
    if (appointmentId) load();
  }, [appointmentId]);

  const PatientInfoCard = () => {
    if (!patient) return <p>Loading patient information...</p>;

    return (
      <Card className="border-0">
        <Card.Body>
  <Row className="align-items-center ">
    <Col>
      <p className="text-primary fw-bold mb-0">
        {patient?.patientFirstName} {patient?.patientLastName}
      </p>
      <div className="mt-1 small">
        {patient?.patientEmail && (
          <>
            <i className="fas fa-envelope me-2 text-primary"></i>
            {patient.patientEmail}
            <br />
          </>
        )}
        {patient?.patientCellNumber && (
          <>
            <i className="fas fa-phone-alt me-2 text-primary"></i>
            {patient.patientCellNumber}
          </>
        )}
      </div>
    </Col>
    <Col className="text-end">
      {/* optional actions (e.g., Show/Hide button) */}
    </Col>
  </Row>
  <Row>
    <strong className="text-primary mt-3" ><i className="fa-solid fa-triangle-exclamation text-warning"></i> The notes are saved on the appointment, and can only be added to the patient once the Patient and Account is created.</strong>
  </Row>
</Card.Body>

      </Card>
    );
  };

  // Left rail actions (FULL HEIGHT)
 



  const renderRightPane = () => {
    if (activeSection === "info") return <PatientInfoCard />;
   // if (activeSection === "cases") return <CasesPane />;
    return null;
  };

  return (
    <div className="ms-1" style={{ marginTop: "75px" }}>
      <Container fluid>
        <Row className="g-0">
          {/* LEFT rail always full height & sticky */}
          

          {/* On mobile, no static rail; right pane drives content */}
          <Col md={10} xs={12}>
            <Container className="pt-2 bg-transparent pb-1 mb-2 ms-2 rounded">
              {renderRightPane()}
            </Container>
          </Col>
        </Row>
      </Container>

      <hr className="mt-0 mb-2" />

      {/* Sessions area (unchanged; role-gated) */}
      <Row className="ms-1 me-2">
        {userRole && (
          <NewPatientSession
            extraMobileMenu={[
              {
                key: "patient-info",
                label: "Patient Info",
                onClick: () => setActiveSection("info"),
              },
              ...(patient?.patientMedicalAid
                ? [
                    {
                      key: "check-patient",
                      label: "Check Patient",
                      onClick: () => setActiveSection("eligibility"),
                    },
                  ]
                : []),
              {
                key: "cases",
                label: "Patient Cases",
                onClick: () => {
                  setActiveSection("cases");
                },
              },
            ]}
            // Let Session tell the parent that a mobile action was taken (so you can scroll to top, etc)
            onMobileNavigate={(where) => {
              if (where === "patient") {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
              // 'session' is also passed when a Session tab is chosen; no action needed here.
            }}
          />
        )}
      </Row>
    </div>
  );
}
